<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'customer-list'"
    :gcPopupCustomerStatementConfig="gcPopupCustomerStatementConfig"
    :loadDataGrid="loaded"
    :setLoading="setLoading"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "../../_mixins/data-grid.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import { FeatureStorage } from "../../_services/storage";
import {
  CustomerTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/customer/customer-tabs";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { SalesRepresentativeService } from "../../_services/api/sales/sales-rep.service";
import { CacheService } from "../../_services/cache/cache-service";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      gcPopupCustomerStatementConfig: {},
      CustomerSalesRepresentativeCode: undefined,
      loaded: false,
      setLoading: false,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Customers",
        selectedIndex: GetIndexByTabName("All"),
        tabs: CustomerTabs,
        exportFileName: "Customers List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CustomerList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              select: ["Code", "Status", "FriendlyActive"].concat(
                this.getSelectFields(this.getColumns)
              ),
            },
            // rowSelect: {
            //   view: this,
            //   page: "sales-order",
            //   mode: "review",
            //   idProperty: "Code",
            // },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Customers",
                message: "Get Started, Add a Customer",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/customer/create",
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission("Customer", "create"),
              },
            ],
            filterOnEnter: true,
          },
          columns: this.getColumns,
        },
      };

      return config;
    },
    getColumns() {
      return [
        {
          screenField: "Customer",
          gridDataField: "Name",
          sortOrder: "asc",
          sortIndex: 0,
          cellTemplateRecord: {
            primary: [
              {
                dataField: "Name",
              },
            ],
            secondary: [
              {
                dataField: "Code",
              },
            ],
          },
          exportFields: [
            {
              dataField: "Code",
              label: "Customer Code",
            },
            {
              dataField: "Name",
              label: "Customer Name",
            },
          ],
          fixed: true,
          fixedPosition: "left",
          allowHiding: false,
        },
        {
          screenField: "CustomerName",
          gridLabel: "CustomerNameFilter", // only added to bypass the having the same 'name' for 2 columns
          visible: false,
          showInColumnChooser: false,
          dataType: "string",
          type: "Text",
          filterIndex: 0,
          filterDataField: "CustomerSearchText",
        },
        // {
        //   screenField: "GSTStatus",
        //   // filterIndex: 7
        // },
        {
          screenField: "BillToCustomer",
          filterIndex: 2,
          visible: false,
        },
        {
          screenField: "CustomerType",
          label: "Type",
          filterIndex: 5,
          maxWidth: ColumnWidth.CustomerType.width,
        },
        {
          screenField: "CustomerTypeDiscountRebatePct",
          visible: false,
          width: 80,
          minWidth: 80,
        },
        {
          screenField: "Abn",
          gridLabel: "ABN",
          filterLabel: "ABN",
          visible: false,
          maxWidth: ColumnWidth.Abn.width,
          filterIndex: 15,
          dataType: "string",
          type: "Text",
        },
        {
          screenField: "Acn",
          gridLabel: "ACN",
          filterLabel: "ACN",
          visible: false,
          maxWidth: ColumnWidth.Acn.width,
          filterIndex: 16,
          dataType: "string",
          type: "Text",
        },
        {
          screenField: "Region",
          label: "Region",
          dataField: "RegionCode",
          maxWidth: ColumnWidth.Region.width,
        },
        {
          screenField: "SubRegion",
          // label: "Region",
          dataField: "SubregionCode",
          cellTemplate: undefined,
          exportFields: undefined,
          maxWidth: ColumnWidth.Region.width,
        },
        // {
        //   screenField: "Market",
        //   // label: "Region",
        //   dataField: "MarketCode",
        // },
        {
          screenField: "Market",
          dataField: "MarketCode",
          filterDataField: "MarketCode",
          filterIndex: 11,
          maxWidth: ColumnWidth.Market.width,
        },

        {
          screenField: "CustomerReportingGroup1",
          dataField: "ReportingGroup1Code",
          filterDataField: "ReportingGroup1Code",
          cellTemplateRecord: {
            primary: [
              {
                dataField: "ReportingGroup1Name",
              },
            ],
            secondary: [
              {
                dataField: "ReportingGroup1Code",
              },
            ],
          },
          exportFields: [
            {
              dataField: "ReportingGroup1Code",
              label: "Reporting Group 1 Code",
            },
            {
              dataField: "ReportingGroup1Name",
              label: "Reporting Group 1 Name",
            },
          ],
          filterIndex: 12,
          // visible: false,
        },
        {
          screenField: "CustomerReportingGroup2",
          dataField: "ReportingGroup2Code",
          filterDataField: "ReportingGroup2Code",
          cellTemplateRecord: {
            primary: [
              {
                dataField: "ReportingGroup2Name",
              },
            ],
            secondary: [
              {
                dataField: "ReportingGroup2Code",
              },
            ],
          },
          exportFields: [
            {
              dataField: "ReportingGroup2Code",
              label: "Reporting Group 2 Code",
            },
            {
              dataField: "ReportingGroup2Name",
              label: "Reporting Group 2 Name",
            },
          ],
          filterIndex: 13,
          visible: false,
        },
        {
          screenField: "CustomerReportingGroup3",
          dataField: "ReportingGroup3Code",
          filterDataField: "ReportingGroup3Code",
          cellTemplateRecord: {
            primary: [
              {
                dataField: "ReportingGroup3Name",
              },
            ],
            secondary: [
              {
                dataField: "ReportingGroup3Code",
              },
            ],
          },
          exportFields: [
            {
              dataField: "ReportingGroup3Code",
              label: "Reporting Group 3 Code",
            },
            {
              dataField: "ReportingGroup3Name",
              label: "Reporting Group 3 Name",
            },
          ],
          filterIndex: 14,
          visible: false,
        },
        {
          screenField: "CustomerRep",
          maxWidth: ColumnWidth.OrderRep.width,
          gridDataField: "SalesRepresentativeFullName",
          filterDataField: "SalesRepresentativeCode",
          label: "Rep",
          cellTemplateRecord: {
            primary: [
              {
                dataField: "SalesRepresentativeFullName",
              },
            ],
            secondary: [
              {
                dataField: "SalesRepresentativeCode",
              },
            ],
          },
          exportFields: [
            {
              dataField: "SalesRepresentativeCode",
              label: "Customer Rep Code",
            },
            {
              dataField: "SalesRepresentativeFullName",
              label: "Customer Rep Full Name",
            },
          ],
          filterIndex: 6,
          filterDefaultValue: this.getCustomerRepDefault,
        },
        {
          screenField: "Currency",
          cellTemplate: null,
          cellTemplateRecord: undefined,
          gridDataField: "CurrencyCode",
          exportFields: undefined,
          width: 80,
          minWidth: 80,
          maxWidth: ColumnWidth.CurrencyCode.width,
          filterIndex: 8,
        },
        {
          screenField: "Terms",
          width: 120,
          minWidth: 120,
          visible: false,
        },
        {
          screenField: "TermCalculation",
          filterLabel: "Terms Method",
          width: 120,
          minWidth: 120,
          visible: false,
          filterIndex: 9,
        },
        {
          screenField: "CreditLimit",
          width: 120,
          minWidth: 120,
          visible: false,
        },
        {
          screenField: "StopCredit",
          allowEditing: false,
          makeReadOnly: () => {
            return true;
          },
          width: 120,
          minWidth: 120,
          filterIndex: 10,
        },
        {
          screenField: "GST",
          filterLabel: "GST Status",
          width: 60,
          minWidth: 60,
          visible: true,
          filterIndex: 7,
        },
        {
          screenField: "WET",
          width: 60,
          minWidth: 60,
          visible: false,
        },
        {
          screenField: "TaxExemptionNumber",
          filterLabel: "Exemption #",
          width: 60,
          minWidth: 60,
          visible: false,
        },
        {
          screenField: "StreetLine1",
          visible: false,
        },
        {
          screenField: "StreetLine2",
          visible: false,
        },
        {
          screenField: "Suburb",
          width: 120,
          minWidth: 120,
          visible: false,
        },
        {
          screenField: "PostCode",
          width: 120,
          minWidth: 120,
          visible: false,
        },
        {
          screenField: "Agent",
          filterIndex: 3,
        },
        {
          screenField: "AgentCommissionPct",
          visible: false,
          width: 100,
          minWidth: 80,
        },
        {
          screenField: "CustomerGroup",
          label: "Group",
          filterIndex: 4,
        },
        {
          screenField: "State",
          width: 120,
          maxWidth: ColumnWidth.State.width,
        },
        {
          screenField: "Country",
          width: 150,
          minWidth: 150,
          maxWidth: ColumnWidth.Country.width,
        },
        // {
        //   screenField: "Agent"
        // },
        // {
        //   screenField: "Agent"
        // },
        {
          screenField: "Status",
          gridDataField: "Inactive",
          gridLabel: "Status",
          filterIndex: 1,
          filterDefaultValue: ["N"],
        },

        {
          screenField: "GridRecordEllipsisMenu",
          select: false,
          allowSearch: false,
          cssClass: "padding-7",
          ellipsisMenu: {
            itemAction: (data) => {
              var items = [
                {
                  menuText: "Invoice",
                  data: data,
                  clickAction: this.goToInvoice,
                  disabled: FeatureStorage.checkPermission("Invoice", "create")
                    ? false
                    : true,
                },
                {
                  menuText: "Credit",
                  data: data,
                  clickAction: this.goToCredit,
                  disabled: FeatureStorage.checkPermission("Invoice", "create")
                    ? false
                    : true,
                },
                {
                  menuText: "Receipt",
                  data: data,
                  visible: data.data.Status == "A" ? true : false,
                  clickAction: this.goToCreateCustomerReceipt,
                  disabled: FeatureStorage.checkPermission(
                    "CashReceipt",
                    "create"
                  )
                    ? false
                    : true,
                },
                {
                  menuText: "Statement",
                  data: data,
                  clickAction: this.goToCustomerStatementModel,
                  disabled: FeatureStorage.checkPermission(
                    "ReportCustomerStatement",
                    "create"
                  )
                    ? false
                    : true,
                },
                {
                  menuText: "Call Log",
                  data: data,
                  clickAction: this.goToCustomerCallLog,
                  disabled: FeatureStorage.checkPermission("CallLogs", "create")
                    ? false
                    : true,
                },
              ];

              return items;
            },
            keyExpr: "menuText",
            displayExpr: "menuText",
          },
          makeDisabled: (data) => {
            // if (data.data.InvoiceTy
            if (data) return data.data.FriendlyActive != "Active";
          },
        },
      ];
    },
    getCustomerRepDefault() {
      if (this.CustomerSalesRepresentativeCode)
        return [this.CustomerSalesRepresentativeCode];
      else return false;
    },
  },
  methods: {
    goToCustomerCallLog(e) {
      this.$router.push({
        path: `/call-logs/create`,
        query: {
          cus_id: e.Code,
          from: "/customer",
        },
      });
    },
    goToCustomerStatementModel(e) {
      this.gcPopupCustomerStatementConfig = {
        visible: true,
        hidden: () => {
          this.gcPopupCustomerStatementConfig.visible = false;
        },
        dataModel: e,
      };
    },
    goToCreateCustomerReceipt(e) {
      this.$router.push({
        path: `/customer-receipt/create/${e.Code}`,
        query: {
          from: "customer-list",
        },
      });
    },
    goToCredit(e) {
      this.$router.push({
        path: `credit-customer/create/${e.Code}`,
      });
    },
    goToInvoice(e) {
      this.$router.push({
        path: `invoice/create/${e.Code}`,
        query: {
          from: "/customer",
        },
      });
    },
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "Status" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        if (FeatureStorage.checkPermission("CustomerDashboard", "review")) {
          this.$router
            .push({ path: `/customer-dashboard/${e.data.Code}` })
            .then((res) => {
              if (res)
                setTimeout(() => {
                  this.reSizeGrid();
                }, 50);
            });
        } else {
          this.onRowClicked(e, {
            view: this,
            page: "customer",
            mode: "review",
            idProperty: "Code",
          });
        }
      }
    },
    async setDefaultCustomerRep() {
      var defaultSalesRep = CacheService.getCache(
        "UserDefaultSalesRepresentative"
      );

      if (!defaultSalesRep) {
        await SalesRepresentativeService.getUserDefaultSalesRepresentative()
          .then((result) => {
            this.setLoading = false;
            if (result.data.value[0].SalesRepresentativeCode != "") {
              this.CustomerSalesRepresentativeCode =
                result.data.value[0].SalesRepresentativeCode;
            }

            CacheService.saveCache(
              "UserDefaultSalesRepresentative",
              result.data.value[0],
              2
            );
            this.loaded = true;
          })
          .catch((err) => {
            if (err) {
              this.setLoading = false;
              this.loaded = true;
            }
          });
      } else {
        if (defaultSalesRep.SalesRepresentativeCode != "")
          this.CustomerSalesRepresentativeCode =
            defaultSalesRep.SalesRepresentativeCode;

        this.setLoading = false;
        this.loaded = true;
      }
    },
  },

  async created() {
    this.setLoading = true;
    await this.setDefaultCustomerRep();
  },
};
</script>

<style lang="scss"></style>
